(function () {
  'use strict';

  // ── Selectors ─────────────────────────────────────────────────────────────

  // The widget's CSS-var root (Recharge sets inline styles here)
  var RC_ROOT = '.rc-widget__root, [data-testid="style-root"]';

  // Price element inside shadow DOM
  var PRICE_EL_SELECTORS = [
    '[data-testid="static-price"]',
    '[data-testid*="price"]',
    '.rc-static-price',
    '.rc-price-text',
    '.rc-pricing-text',
    '.rc-badge__price',
    '.rc-widget__price',
    '.rc-header__price',
    '.rc-purchase-option__price',
    '[part*="price"]',
    '[class*="price"]',
  ];

  // Class names we add (safe namespace)
  var BADGE_CLASS   = 'rc-kcd-price-badge';
  var HIDDEN_CLASS  = 'rc-kcd-hidden';

  // Plan button order as rendered by Recharge — used both for the interval
  // label text (see manipulateSingleRoot) and for picking the default plan.
  var LABELS = ['Quarterly', 'Annually'];

  // Index into LABELS/plan-button list that should be selected by default.
  // 0 = Quarterly, 1 = Annually.
  var DEFAULT_PLAN_INDEX = 0;

  // ── CSS injected into the shadow root ────────────────────────────────────

  var SHADOW_CSS = [
    /* ── CSS var overrides — !important beats Recharge inline styles ── */
    RC_ROOT + ' {',
    '  --rc-widget-brand-color:           #001a70 !important;',
    '  --rc-widget-brand-contrast-color:  #ffffff !important;',
    '  --rc-widget-brand-color-80:        rgba(0,26,112,0.80) !important;',
    '  --rc-widget-text-color:            #001a70 !important;',
    '  --rc-widget-selected-bg-color:     #001a70 !important;',
    '  --rc-widget-selected-text-color:   #ffffff !important;',
    '  --rc-widget-badge-bg-color:        #ee7a41 !important;',
    '  --rc-widget-badge-text-color:      #ffffff !important;',
    '  --rc-widget-card-radius:           9999px  !important;',
    '  --rc-widget-button-radius:         9999px  !important;',
    '  --rc-widget-badge-radius:          4px     !important;',
    '  --rc-widget-field-radius:          4px     !important;',
    '  background: transparent !important;',
    '  position: relative;',
    '}',

    /* ── Global font ── */
    '* { font-family: "TayBirdie", "Optima", serif; }',

    /* ── Kill the outer subscription card oval (the big blue blob) ──
       These are all known Recharge class/testid patterns for the top-level
       "subscription vs one-time" card. It should be transparent. */
    '.rc-purchase-option,',
    '[data-testid="purchase-option-subscription"],',
    '[data-testid="subscription-option"],',
    '[data-testid^="purchase-option"] {',
    '  background: transparent !important;',
    '  background-color: transparent !important;',
    '  border: none !important;',
    '  box-shadow: none !important;',
    '  border-radius: 0 !important;',
    '  padding: 0 !important;',
    '  color: #001a70 !important;',
    '}',

    /* Also reset any --selected / --active modifier on the outer card */
    '[class*="rc-purchase-option"][class*="selected"],',
    '[class*="rc-purchase-option"][class*="active"],',
    '[class*="rc-purchase-option"][aria-checked="true"] {',
    '  background: transparent !important;',
    '  box-shadow: none !important;',
    '}',

    /* ── Fieldset reset ── */
    'fieldset { border: none; padding: 0; margin: 0; width: 100%; }',

    /* ── Uppercase / letter-spacing on labels and headings ── */
    'label, button, h1, h2, h3, h4,',
    '[part*="label"], [part*="title"], [part*="heading"] {',
    '  text-transform: uppercase;',
    '  letter-spacing: 1px;',
    '}',

    /* ── Our injected price badge ── */
    '.' + BADGE_CLASS + ' {',
    '  position: absolute;',
    '  top: 0;',
    '  right: 0;',
    '  display: inline-flex;',
    '  align-items: center;',
    '  background: #ee7a41;',
    '  color: #001a70;',
    '  border-radius: 4px;',
    '  padding: 0.35em 0.75em;',
    '  font-family: "TayBirdie", "Optima", serif;',
    '  font-size: 0.875rem;',
    '  font-weight: bold;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.05em;',
    '  white-space: nowrap;',
    '  line-height: 1.4;',
    '}',

    /* ── Sub-container: remove side padding ── */
    '.rc-purchase-option__sub-container {',
    '  padding-left: 0 !important;',
    '  padding-right: 0 !important;',
    '  padding-bottom: 0 !important;',
    '}',

    /* ── rc-purchase-option__label.single-selection: strip padding ── */
    '.rc-purchase-option__label.single-selection {',
    '  padding: 0 !important;',
    '}',

    /* ── rc-purchase-option__selector: heading above the plan buttons ── */
    '.rc-purchase-option__selector {',
    '  font-size: 1em !important;',
    '  margin-bottom: 20px !important;',
    '}',

    /* ── rc-plans-button: interval plan selector buttons ──
       Selected state = data-checked="" present. Unselected = no data-checked. */
    '.rc-plans-button {',
    '  min-height: 30px !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  border: 2px solid #001a70 !important;',
    '}',
    '.rc-plans-button:not([data-checked]) {',
    '  background: transparent !important;',
    '  border: 2px solid #001a70 !important;',
    '}',
    '.rc-plans-button-list .rc-plans-button {',
    '  justify-content: space-between !important;',
    '  padding: 0 20px !important;',
    '}',

    /* ── rc-learn-more and rc-price: hide ── */
    '.rc-learn-more, .rc-price { display: none !important; }',

    /* ── rc-plans__label: replace Lit-managed "Pay Every" text via CSS ──
       font-size:0 + color:transparent collapses the Lit-rendered text to nothing.
       ::before with explicit rem/color shows our replacement text.
       This beats specificity fights with visibility:hidden better than that approach. */
    '.rc-plans__label {',
    '  font-size: 0 !important;',
    '  color: transparent !important;',
    '  letter-spacing: -9999px !important;',
    '  margin-bottom: 10px !important;',
    '}',
    '.rc-plans__label::before {',
    '  content: "PAYMENT TYPE:";',
    '  display: inline-block;',
    '  font-size: 1rem;',        /* rem avoids inheriting 0 from parent */
    '  color: #001a70;',
    '  font-family: "TayBirdie", "Optima", serif;',
    '  text-transform: uppercase;',
    '  letter-spacing: 1px;',
    '  font-weight: normal;',
    '}',

    /* ── Benefits list ── */
    '.rc-benefits__list {',
    '  margin-bottom: 20px !important;',
    '}',

    /* ── Benefits list items ──
       The <ul> lives inside div.rc-benefits__list with no classes on the <li>s. */
    '.rc-benefits__list li {',
    '  font-family: "Optima", serif !important;',
    '  font-style: normal !important;',
    '  font-weight: 400 !important;',
    '  font-size: 16px !important;',
    '  line-height: 24px !important;',
    '  color: #001a70 !important;',
    '}',

    /* ── rc-plans-button__interval: replace Lit-managed "3 months" text ──
       JS sets data-kcd-interval on the <span> itself (the ::before originating
       element). content:attr() reads from the originating element — previously
       we set the attr on the parent div which is why attr() returned nothing. */
    '.rc-plans-button__interval[data-kcd-interval] {',
    '  font-size: 0 !important;',
    '  letter-spacing: -9999px !important;',
    '}',
    '.rc-plans-button__interval[data-kcd-interval]::before {',
    '  content: attr(data-kcd-interval);',
    '  display: inline-block;',
    '  font-size: 1rem;',
    '  color: inherit;',         /* inherits button text color: white (selected) or navy (unselected) — do NOT set color: transparent on the span or this breaks */
    '  font-family: "TayBirdie", "Optima", serif;',
    '  text-transform: uppercase;',
    '  letter-spacing: 1px;',
    '}',

    /* ── Hide utility ── */
    '.' + HIDDEN_CLASS + ' { display: none !important; }',
  ].join('\n');

  // ── Shadow root helpers ───────────────────────────────────────────────────

  // Collect all nested shadow roots inside a given root (recursive).
  // The widget has 3 nested shadow hosts — our CSS/JS must reach into each one.
  function getAllShadowRoots(root) {
    var nested = [];
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        nested.push(el.shadowRoot);
        nested = nested.concat(getAllShadowRoots(el.shadowRoot));
      }
    });
    return nested;
  }

  // ── Style injection ───────────────────────────────────────────────────────
  // kcdSheet is shared — created once, reused across all shadow root injections.
  var kcdSheet = null;

  function injectIntoOne(oneRoot) {
    try {
      if (!kcdSheet) {
        kcdSheet = new CSSStyleSheet();
        kcdSheet.replaceSync(SHADOW_CSS);
      }
      var existing = Array.from(oneRoot.adoptedStyleSheets);
      if (existing.indexOf(kcdSheet) === -1) {
        oneRoot.adoptedStyleSheets = existing.concat(kcdSheet);
      }
    } catch (_) {
      if (!oneRoot.querySelector('style[data-kcd]')) {
        var s = document.createElement('style');
        s.setAttribute('data-kcd', '');
        s.textContent = SHADOW_CSS;
        oneRoot.appendChild(s);
      }
    }
  }

  // Inject CSS into the top-level shadow root AND all nested shadow roots.
  function injectStyles(sr) {
    injectIntoOne(sr);
    getAllShadowRoots(sr).forEach(injectIntoOne);
  }

  // ── DOM helpers ───────────────────────────────────────────────────────────

  function findFirst(root, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      try {
        var el = root.querySelector(selectors[i]);
        if (el) return el;
      } catch (_) {}
    }
    return null;
  }

  // Replace all occurrences of a string across all text nodes in a subtree
  function replaceText(root, find, replace) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(find) !== -1) {
        node.nodeValue = node.nodeValue.split(find).join(replace);
      }
    }
  }

  // Hide leaf elements whose full text matches any of the supplied regex patterns
  function hideMatchingLeaves(root, patterns) {
    var allEls = root.querySelectorAll('*');
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      if (el.children.length > 0) continue; // only leaf nodes
      var text = (el.textContent || '').trim();
      for (var p = 0; p < patterns.length; p++) {
        if (patterns[p].test(text)) {
          el.classList.add(HIDDEN_CLASS);
          break;
        }
      }
    }
  }

  // ── Plan / price data ─────────────────────────────────────────────────────

  function buildPlanData() {
    var dataEl = document.querySelector('.js-recharge-plan-data');
    if (!dataEl) return { cadenceMap: {}, priceMap: {}, basePrice: 0, currency: 'GBP' };

    var groups;
    try {
      groups = JSON.parse(dataEl.getAttribute('data-selling-plans') || '[]');
    } catch (_) {
      groups = [];
    }

    var basePrice = parseInt(dataEl.getAttribute('data-base-price') || '0', 10);
    var currency  = dataEl.getAttribute('data-currency') || 'GBP';
    var cadenceMap = {};
    var priceMap   = {};

    groups.forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        var id    = String(plan.id);
        var lower = (plan.name || '').toLowerCase();

        // Cadence label
        var cadence;
        if (lower.indexOf('quarter') !== -1 || lower.indexOf('3 month') !== -1) {
          cadence = 'per quarter';
        } else if (lower.indexOf('annual') !== -1 || lower.indexOf('year') !== -1) {
          cadence = 'per annum';
        } else {
          cadence = plan.name || '';
        }
        cadenceMap[id] = cadence;

        // Price calculation from adjustment
        var adj = (plan.price_adjustments || [])[0];
        if (adj && basePrice > 0) {
          var price;
          if (adj.value_type === 'price') {
            price = adj.value;
          } else if (adj.value_type === 'percentage') {
            price = Math.round(basePrice * (1 - adj.value / 100));
          } else if (adj.value_type === 'fixed_amount') {
            price = basePrice - adj.value;
          } else {
            price = basePrice;
          }
          priceMap[id] = price;
        } else if (basePrice > 0) {
          priceMap[id] = basePrice;
        }
      });
    });

    return { cadenceMap: cadenceMap, priceMap: priceMap, basePrice: basePrice, currency: currency };
  }

  function formatPrice(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  // ── Selected plan ID ──────────────────────────────────────────────────────
  // Recharge v2 may use custom elements rather than a native <select> or
  // <input type="radio">, so we try every known pattern before giving up.

  function getSelectedPlanId(sr) {
    // Search both the top-level shadow root and all nested shadow roots.
    var allRoots = [sr].concat(getAllShadowRoots(sr));

    for (var r = 0; r < allRoots.length; r++) {
      var root = allRoots[r];

      // 1. Native select
      var sel = root.querySelector('select[name="selling_plan"]');
      if (sel && sel.value) return String(sel.value);

      // 2. Native radio
      var checked = root.querySelector('input[name="selling_plan"]:checked');
      if (checked) return String(checked.value);

      // 3. Hidden input (some Recharge versions)
      var hidden = root.querySelector('input[name="selling_plan"]');
      if (hidden && hidden.value) return String(hidden.value);

      // 4. aria-checked element with a data-selling-plan-id attribute
      var ariaEl = root.querySelector(
        '[aria-checked="true"][data-selling-plan-id],' +
        '[aria-selected="true"][data-selling-plan-id],' +
        '[data-selling-plan-id][class*="selected"],' +
        '[data-selling-plan-id][class*="active"]'
      );
      if (ariaEl) {
        var idA = ariaEl.getAttribute('data-selling-plan-id') ||
                  ariaEl.getAttribute('data-id') ||
                  ariaEl.getAttribute('value') || '';
        if (idA) return String(idA);
      }

      // 5. aria-checked element with a plain value attribute
      var ariaVal = root.querySelector(
        '[aria-checked="true"][value],' +
        '[aria-selected="true"][value]'
      );
      if (ariaVal) {
        var v = ariaVal.getAttribute('value') || '';
        if (v) return String(v);
      }
    }

    // 6. Outer DOM — Recharge may update the main product form's field
    var outerInput = document.querySelector(
      'select[name="selling_plan"],' +
      'input[name="selling_plan"]'
    );
    if (outerInput && outerInput.value) return String(outerInput.value);

    return '';
  }

  // ── Default plan selection ────────────────────────────────────────────────
  // Recharge itself decides the initial selection (normally the first plan
  // button — Quarterly). To default to Annually instead, we simulate a click
  // on the plan button at DEFAULT_PLAN_INDEX once the buttons exist. This
  // goes through Recharge's own click handling (same path a real user click
  // takes), so its internal state / form field stay in sync — we don't try
  // to fake the selection purely with attributes.
  //
  // Returns true if a click was dispatched (caller should wait a beat before
  // reading the "selected" plan), false if there was nothing to click yet.
  function selectDefaultPlan(sr) {
    var roots = [sr].concat(getAllShadowRoots(sr));
    for (var r = 0; r < roots.length; r++) {
      var buttons = roots[r].querySelectorAll('.rc-plans-button-list .rc-plans-button');
      if (buttons.length > DEFAULT_PLAN_INDEX) {
        var targetBtn = buttons[DEFAULT_PLAN_INDEX];
        if (!targetBtn.hasAttribute('data-checked')) {
          targetBtn.click();
          return true;
        }
        return false; // already selected
      }
    }
    return false; // buttons not rendered yet
  }

  // ── Price badge ───────────────────────────────────────────────────────────

  function ensureBadge(sr) {
    var existing = sr.querySelector('.' + BADGE_CLASS);
    if (existing) return existing;

    var badge = document.createElement('span');
    badge.className = BADGE_CLASS;

    // Append to the CSS-var root so position:absolute top/right lands correctly
    var root = sr.querySelector(RC_ROOT);
    if (root) {
      root.insertBefore(badge, root.firstChild);
    } else {
      sr.appendChild(badge);
    }
    return badge;
  }

  function updateBadge(sr, planId, data) {
  var badge   = ensureBadge(sr);
  var cadence = data.cadenceMap[planId] || '';
  var price   = data.priceMap[planId];
  var text    = '';

  if (price !== undefined) {
    if (cadence === 'per annum') {
      // Show only the per-quarter equivalent, not the annual total
      var quarterlyEquivalent = Math.round(price / 4);
      text = formatPrice(quarterlyEquivalent, data.currency) + ' PER QUARTER';
    } else {
      text = formatPrice(price, data.currency);
      if (cadence) text += ' ' + cadence.toUpperCase();
    }
  } else {
    // Fallback: read from shadow DOM price element
    var priceEl = findFirst(sr, PRICE_EL_SELECTORS);
    if (priceEl) {
      text = priceEl.textContent.trim();
      if (cadence) text += ' ' + cadence.toUpperCase();
    } else {
      console.info(
        '[KCD] Cannot find price element in widget shadow DOM. ' +
        'Run in console to discover selector:\n' +
        "  [...document.querySelector('recharge-subscription-widget')" +
        '.shadowRoot.querySelectorAll(\'*\')]' +
        ".filter(e => /price|badge|static/i.test(e.className+(e.dataset.testid||'')))" +
        ".map(e => ({tag:e.tagName, cls:e.className, testid:e.dataset.testid}))"
      );
    }
  }

  if (text) badge.textContent = text;
}

  // ── Page price update ─────────────────────────────────────────────────────

  function updatePagePrice(planId, data) {
  var price = data.priceMap[planId];
  if (price === undefined) return;

  var formatted = formatPrice(price, data.currency);

  var selectors = [
    '.product-single__box__block--price .money',
    '.product-single__box__block--price [class*="money"]',
    '.sticky-add-to-cart__price .money',
  ];

  selectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.textContent = formatted;
    });
  });
}

function syncSellingPlanInputs(planId) {
  if (!planId) return;

  // Native selects (any form on the page, including cloned sticky-bar forms)
  document.querySelectorAll('select[name="selling_plan"]').forEach(function (sel) {
    if (sel.value !== planId) {
      sel.value = planId;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Hidden/native inputs
  document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
    if (input.type === 'radio') return; // handled below
    if (input.value !== planId) {
      input.value = planId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Radio buttons, if the theme uses those instead
  document.querySelectorAll('input[name="selling_plan"][type="radio"]').forEach(function (radio) {
    var shouldBeChecked = (radio.value === planId);
    if (radio.checked !== shouldBeChecked) {
      radio.checked = shouldBeChecked;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

  // ── DOM text manipulation ─────────────────────────────────────────────────

  // Operate on a single shadow root (or any DOM root).
  // Called for the top-level sr AND every nested shadow root.
  function manipulateSingleRoot(root) {
    // rc-purchase-option__selector: lock to "Subscription".
    // Recharge changes this per-plan (e.g. "Join The Club" for annual).
    var selector = root.querySelector('.rc-purchase-option__selector');
    if (selector && selector.textContent.trim() !== 'Subscription') {
      selector.textContent = 'Subscription';
    }

    // rc-plans-button__interval: these spans are Lit-managed so we set a
    // data attribute (never textContent). CSS reads it via content: attr().
    root.querySelectorAll('.rc-plans-button__interval').forEach(function (span, idx) {
      var label = LABELS[idx] || '';
      if (label && span.getAttribute('data-kcd-interval') !== label) {
        span.setAttribute('data-kcd-interval', label);
      }
    });

    hideMatchingLeaves(root, [
      /^Pay every \d+/i,
      /^every \d+ months?/i,
    ]);
  }

  // Run manipulateSingleRoot across the top-level shadow root and all nested ones.
  // The widget contains 3 nested shadow hosts — the plan labels and learn-more
  // div live inside those nested roots, not in sr itself.
  function manipulateDOM(sr) {
    [sr].concat(getAllShadowRoots(sr)).forEach(manipulateSingleRoot);
  }


  // ── Network interception: force selling_plan onto every /cart/add request ──
// The sticky-add-to-cart app builds its own request body internally and does
// NOT read the selling_plan value from any DOM input at submit time (confirmed:
// added cart line items had no selling_plan key at all — falling back to a
// one-time purchase). Patching fetch/XHR is the only reliable way to guarantee
// the currently-selected plan is actually submitted, independent of how the
// sticky app (or any other add-to-cart button on the page) builds its request.
var currentPlanId = '';

(function patchCartAdd() {
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (currentPlanId && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
        init = injectSellingPlanIntoInit(init);
      }
    } catch (_) {}
    return origFetch.apply(this, arguments);
  };

  function injectSellingPlanIntoInit(init) {
    try {
      var contentType = (init.headers && (init.headers['Content-Type'] || init.headers['content-type'])) || '';
      if (typeof init.body === 'string') {
        if (contentType.indexOf('application/json') !== -1 || /^\s*\{/.test(init.body)) {
          var obj = JSON.parse(init.body);
          if (obj && !obj.selling_plan) {
            if (obj.items && Array.isArray(obj.items)) {
              obj.items.forEach(function (it) { if (!it.selling_plan) it.selling_plan = currentPlanId; });
            } else {
              obj.selling_plan = currentPlanId;
            }
            init.body = JSON.stringify(obj);
          }
        } else {
          // urlencoded form body
          if (init.body.indexOf('selling_plan=') === -1) {
            init.body += (init.body ? '&' : '') + 'selling_plan=' + encodeURIComponent(currentPlanId);
          }
        }
      } else if (init.body instanceof FormData) {
        if (!init.body.has('selling_plan')) {
          init.body.append('selling_plan', currentPlanId);
        }
      }
    } catch (_) {}
    return init;
  }

  // Also patch XHR, in case the app uses XMLHttpRequest instead of fetch
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._kcdIsCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this._kcdIsCartAdd && currentPlanId && body) {
        if (typeof body === 'string') {
          if (/^\s*\{/.test(body)) {
            var obj = JSON.parse(body);
            if (obj && !obj.selling_plan) {
              if (obj.items && Array.isArray(obj.items)) {
                obj.items.forEach(function (it) { if (!it.selling_plan) it.selling_plan = currentPlanId; });
              } else {
                obj.selling_plan = currentPlanId;
              }
              body = JSON.stringify(obj);
            }
          } else if (body.indexOf('selling_plan=') === -1) {
            body += (body ? '&' : '') + 'selling_plan=' + encodeURIComponent(currentPlanId);
          }
        } else if (body instanceof FormData && !body.has('selling_plan')) {
          body.append('selling_plan', currentPlanId);
        }
      }
    } catch (_) {}
    return origSend.call(this, body);
  };
})();

  // ── Main init ─────────────────────────────────────────────────────────────

  function init() {
    var widgetEl = document.querySelector('recharge-subscription-widget');
    if (!widgetEl) return;
    var sr = widgetEl.shadowRoot;
    if (!sr) return;

    var data = buildPlanData();
    var attempts = 0;
    var defaultSelectAttempts = 0;

    function tryInit() {
      var rootEl = sr.querySelector(RC_ROOT);
      if (!rootEl) {
        if (++attempts < 30) setTimeout(tryInit, 100);
        return;
      }

      // 1. Inject shadow DOM styles
      injectStyles(sr);

      // 2. Text / subtitle DOM manipulation
      manipulateDOM(sr);

      // 3. Force the default plan (Annually) before we read/report the
      //    selected plan, so the badge/page price reflect it from the start.
      //    Plan buttons can render a tick after RC_ROOT appears, so retry a
      //    few times if they're not there yet.
      var didClick = selectDefaultPlan(sr);
      if (!didClick && defaultSelectAttempts < 20) {
        var buttonsExist = [sr].concat(getAllShadowRoots(sr)).some(function (root) {
          return root.querySelectorAll('.rc-plans-button-list .rc-plans-button').length > DEFAULT_PLAN_INDEX;
        });
        if (!buttonsExist) {
          defaultSelectAttempts++;
          setTimeout(tryInit, 100);
          return;
        }
      }

      finishInit(didClick);
    }

    function finishInit(didClick) {
      // Give Recharge's Lit re-render a beat to settle after our click
      // before reading back which plan is now selected.
      setTimeout(function () {
        // 4. Price badge — use detected plan or fall back to first plan in data
        var planId = getSelectedPlanId(sr);
        if (!planId) planId = Object.keys(data.cadenceMap)[0] || '';
        if (planId) {
          updateBadge(sr, planId, data);
          updatePagePrice(planId, data);
          syncSellingPlanInputs(planId);
          currentPlanId = planId; 
        }

        // 5. React to plan changes — listen to both change and click since
        //    Recharge v2 may not fire change events for custom plan selectors
        var lastPlanId = planId;
        function onPlanMaybeChanged() {
          setTimeout(function () {
            // Re-run DOM fixes — Recharge may have changed selector text on plan switch
            manipulateDOM(sr);
            var newId = getSelectedPlanId(sr);
            if (!newId) {
              // Log once so the right selector can be found and added above
              if (!sr._kcdDetectLogged) {
                sr._kcdDetectLogged = true;
                console.info(
                  '[KCD] Plan ID not detected after selection. Run in console to discover:\n' +
                  "  sr = document.querySelector('recharge-subscription-widget').shadowRoot\n" +
                  "  ;[...sr.querySelectorAll('[aria-checked],[aria-selected],[data-selling-plan-id],[value],[class*=selected],[class*=active]')]\n" +
                  "  .map(e => ({tag:e.tagName, cls:e.className, ariaCk:e.getAttribute('aria-checked'), ariaSel:e.getAttribute('aria-selected'), spid:e.getAttribute('data-selling-plan-id'), val:e.getAttribute('value')}))"
                );
              }
              return;
            }
            if (newId !== lastPlanId) {
              lastPlanId = newId;
              currentPlanId = newId; 
              updateBadge(sr, newId, data);
              updatePagePrice(newId, data);
              syncSellingPlanInputs(newId);
            }
          }, 200);
        }
        sr.addEventListener('change', onPlanMaybeChanged);
        sr.addEventListener('click',  onPlanMaybeChanged);

        // 6. Watch shadow DOM for both structural re-renders and attribute changes
        //    (aria-checked / class toggle) that signal a plan selection change
        var observer = new MutationObserver(function (mutations) {
          var hasAdditions  = false;
          var hasAttrChange = false;
          mutations.forEach(function (m) {
            if (m.type === 'attributes') {
              hasAttrChange = true;
            } else if (m.type === 'childList') {
              // Only treat as "addition" when a real element (not a text node
              // or our own badge) was added — prevents loops from textContent= calls
              Array.from(m.addedNodes).forEach(function (n) {
                if (n.nodeType === 1 &&
                    !(n.classList && n.classList.contains(BADGE_CLASS))) {
                  hasAdditions = true;
                }
              });
            }
          });

          if (hasAdditions) {
            // Re-inject styles into all shadow roots (incl. any new nested ones)
            injectStyles(sr);
            manipulateDOM(sr);
            // Observe any newly appeared nested shadow roots
            attachNestedObservers();
            // Re-inject badge if Recharge's re-render wiped it
            if (!sr.querySelector('.' + BADGE_CLASS) && lastPlanId) {
              updateBadge(sr, lastPlanId, data);
            }
          }

          if (hasAttrChange) {
            setTimeout(function () {
              var newId = getSelectedPlanId(sr);
              if (newId && newId !== lastPlanId) {
                lastPlanId = newId;
                currentPlanId = newId; 
                updateBadge(sr, newId, data);
                updatePagePrice(newId, data);
                syncSellingPlanInputs(newId);
              }
            }, 50);
          }
        });
        observer.observe(sr, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'aria-selected', 'class', 'value'],
        });

        // Observe each nested shadow root independently — MutationObserver with
        // subtree:true on sr does NOT pierce shadow boundaries, so changes inside
        // nested roots (Lit re-renders, aria-checked toggles) are invisible to the
        // main observer unless we watch each nested root directly.
        function attachNestedObservers() {
          getAllShadowRoots(sr).forEach(function (nestedRoot) {
            if (nestedRoot._kcdObserved) return;
            nestedRoot._kcdObserved = true;

            var nestedObs = new MutationObserver(function (mutations) {
              var hasEl   = false;
              var hasAttr = false;
              mutations.forEach(function (m) {
                if (m.type === 'attributes') { hasAttr = true; }
                else if (m.type === 'childList') {
                  Array.from(m.addedNodes).forEach(function (n) {
                    if (n.nodeType === 1 &&
                        !(n.classList && n.classList.contains(BADGE_CLASS))) {
                      hasEl = true;
                    }
                  });
                }
              });
              if (hasEl) {
                injectIntoOne(nestedRoot);
                manipulateSingleRoot(nestedRoot);
              }
              if (hasAttr) {
                setTimeout(function () {
                  var newId = getSelectedPlanId(sr);
                  if (newId && newId !== lastPlanId) {
                    lastPlanId = newId;
                    currentPlanId = newId;   
                    updateBadge(sr, newId, data);
                    updatePagePrice(newId, data);
                  }
                }, 50);
              }
            });
            nestedObs.observe(nestedRoot, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['aria-checked', 'aria-selected', 'class', 'value'],
            });
          });
        }

        attachNestedObservers();
      }, didClick ? 200 : 0);
    }

    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();